import React from "react";
import { Button, keyframes } from "@mui/material";

const dropIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-12px);
  }

  60% {
    opacity: 1;
    transform: translateY(2px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const HiddenButton = ({
  icon,
  label,
  onClick,
  variant = "outlined",
  color,
  delay = 0,
  expandedWidth = 220,
  collapsedWidth = 40,
  disabled = false,
  sx = {},
  ...rest
}) => {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      color={color}
      disabled={disabled}
      sx={{
        // 基础布局
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-start",

        // 尺寸
        width: collapsedWidth,
        minWidth: collapsedWidth,
        maxWidth: expandedWidth,

        // 防止内容撑开
        overflow: "hidden",
        whiteSpace: "nowrap",

        // padding
        px: "8px",

        // MUI Button 默认的一些行为
        textTransform: "none",

        // 动画
        transition: "width 0.3s ease, padding 0.3s ease",
        animation: `${dropIn} 0.4s ease-out ${delay}s both`,

        // icon
        "& .hidden-btn-icon": {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,

          width: 24,
          height: 24,
        },

        "& .hidden-btn-label": {
          display: "inline-block",
          whiteSpace: "nowrap",

          opacity: 0,
          maxWidth: 0,
          marginLeft: 0,

          clipPath: "inset(0 100% 0 0)",

          transition:
            "max-width 0.35s ease, " +
            "opacity 0.2s ease 0.1s, " +
            "clip-path 0.35s ease 0.05s, " +
            "margin-left 0.3s ease",
        },

        "&:hover": {
          width: expandedWidth,

          "& .hidden-btn-label": {
            opacity: 1,
            maxWidth: "180px",
            marginLeft: "8px",

            clipPath: "inset(0 0 0 0)",
          },
        },

        ...sx,
      }}
      {...rest}
    >
      <span className='hidden-btn-icon'>{icon}</span>

      <span className='hidden-btn-label'>{label}</span>
    </Button>
  );
};

export default HiddenButton;
